export default function addresses(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                address: action.address,
            }
        case 'ADD_CURRENT_ORGANIZATION':
            return {
                ...state,
                address: action.address,
                organization: action.organization,

            }
        default:
            return state;
    }
}
